import React, { useEffect, useContext, useState } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { Footer, Header, Aside, Main } from '../..';
import { AppContext } from '../../../contexts';
import { Box } from '@mui/joy';

const Full = () => {

    const { setCurrentModuleName, modules } = useContext(AppContext);
    const [isOpen, setIsOpen] = useState();
    const location = useLocation();
    
    useEffect(() => {
        for (const [key, module] of Object.entries(modules)) {
            if (module.hasOwnProperty('menuItem') && module.menuItem.href === location.pathname) { 
                setCurrentModuleName(module.menuItem.title);
            }
        }
    }, [location]);

    useEffect(() => {
        setIsOpen((localStorage.getItem('prefersAsideOpen') === 'true') ?? true);
    }, [])

    const handleIsOpen = () => {
        setIsOpen(!isOpen);
    }

    return (
        <Box className={(isOpen) ? 'app open' : 'app closed'}>
            <div className="superheader"></div>
            <Aside onOpenLayout={handleIsOpen}/>
            <Header />
            <Main>
                <Outlet />
            </Main>

            <Footer />
        </Box>
    );
};

export default Full;
